export const CHECKOUT2_PARTICIPANTS_FORMDATA=`CHECKOUT2_PARTICIPANTS_FORMDATA`;
export const CHECKOUT2_PARTICIPANTS_COUNT_INCREMENT=`CHECKOUT2_PARTICIPANTS_COUNT_INCREMENT`;
export const CHECKOUT2_PARTICIPANTS_COUNT_DECREMENT=`CHECKOUT2_PARTICIPANTS_COUNT_DECREMENT`;
export const CHECKOUT2_PARTICIPANTS_COUNT_INITIAL=`CHECKOUT2_PARTICIPANTS_COUNT_INITIAL`;
export const CHECKOUT2_CUSTOMERAS_PARTICIPANTS_FORMDATA=`CHECKOUT2_CUSTOMERAS_PARTICIPANTS_FORMDATA`
export const CHECKOUT2_PARTICIPANTS_FORMDATA_CLEAR=`CHECKOUT2_PARTICIPANTS_FORMDATA_CLEAR`